var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9999,
    cy: 11.9997,
    r: 11.0018,
    style: {
      fill: "var(--teal-50)"
    },
    stroke: "white",
    strokeWidth: 1.32979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7488 10.7397L13.6793 8.67018M7.72949 16.6895L9.48047 16.4949C9.6944 16.4711 9.80136 16.4592 9.90134 16.4269C9.99004 16.3982 10.0745 16.3576 10.1523 16.3063C10.24 16.2484 10.3161 16.1723 10.4683 16.0201L17.3009 9.18755C17.8724 8.61608 17.8724 7.68953 17.3009 7.11806C16.7294 6.54659 15.8029 6.54658 15.2314 7.11806L8.39883 13.9506C8.24663 14.1028 8.17053 14.1789 8.11268 14.2667C8.06135 14.3445 8.02078 14.4289 7.99207 14.5176C7.9597 14.6176 7.94781 14.7245 7.92405 14.9385L7.72949 16.6895Z",
    style: {
      stroke: "var(--teal-600)"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profile-edit.32939a53.svg";
export { ForwardRef as ReactComponent };